<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="库存查询"> </pageTitle>
    <basicList ref="table" :config="basicListconfig" @search="searchEvent">
      <template v-slot:otherOperations>
        <div class="search_total">
          <el-checkbox
            v-model="showZeroStock"
            style="margin-right: 12px"
          >
            显示0库存
          </el-checkbox>
          <!-- // 判断是否为加盟商，100 为醉真实 -->
          <template v-if="compId != 100">
            <p>
              <span>总货值：</span>
              ¥{{ summarizeData.total_money | money }}
              <span class="sub-info">
                （自营：¥{{ summarizeData.self_total_money | money }}，非自营：¥{{ summarizeData.non_self_total_money | money }}）
              </span>
            </p>
            <p>
              <span>总数量：</span>
              {{ summarizeData.total_num }}
              <span class="sub-info">
                （自营：{{ summarizeData.self_total_num }}，非自营：{{ summarizeData.non_self_total_num }}）
              </span>
            </p>
          </template>
          <template v-else>
            <p><span>总货值：</span>¥{{ summarizeData.total_money | money }}</p>
            <p><span>总数量：</span>{{ summarizeData.total_num }}</p>
          </template>
          <!-- -->
        </div>
      </template>
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height"
          >
            <el-table-column width="100" prop="class_name" label="商品分类">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品分类"
                  placement="top-start"
                >
                  <span> 商品分类</span>
                </el-tooltip>
              </template></el-table-column
            >
            <el-table-column width="150" prop="item_number" label="商品编码">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品编码"
                  placement="top-start"
                >
                  <span> 商品编码</span>
                </el-tooltip>
              </template></el-table-column
            >

            <el-table-column min-width="200" prop="name" label="商品名称">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="商品名称"
                  placement="top-start"
                >
                  <span> 商品名称</span>
                </el-tooltip>
              </template></el-table-column
            >
            <el-table-column
              v-if="
                basicListconfig.data.length &&
                basicListconfig.data[0].shop_list &&
                basicListconfig.data[0].shop_list.length
              "
              label="店铺库存"
              align="center"
            >
              <el-table-column
                width="100"
                prop="shop_item_stock_single"
                label="散"
              >
                <template #header>
                  <el-tooltip effect="dark" content="散" placement="top-start">
                    <span> 散</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                width="100"
                prop="shop_item_stock_package"
                label="箱"
              >
                <template #header>
                  <el-tooltip effect="dark" content="箱" placement="top-start">
                    <span> 箱</span>
                  </el-tooltip>
                </template></el-table-column
              >
              <el-table-column width="100" prop="shop_num" label="总">
                <template #header>
                  <el-tooltip effect="dark" content="总" placement="top-start">
                    <span> 总</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="shop_freeze_num" label="冻">
                <template #header>
                  <el-tooltip effect="dark" content="冻" placement="top-start">
                    <span> 冻</span>
                  </el-tooltip>
                </template></el-table-column
              >
            </el-table-column>

            <el-table-column label="总库存" align="center">
              <el-table-column width="100" prop="item_stock_single" label="散">
                <template #header>
                  <el-tooltip effect="dark" content="散" placement="top-start">
                    <span> 散</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="item_stock_package" label="箱">
                <template #header>
                  <el-tooltip effect="dark" content="箱" placement="top-start">
                    <span> 箱</span>
                  </el-tooltip>
                </template></el-table-column
              >
              <el-table-column width="100" prop="num" label="总">
                <template #header>
                  <el-tooltip effect="dark" content="总" placement="top-start">
                    <span> 总</span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    @click="editShopStockNumButton(scope.row)"
                  >
                    {{ scope.row.num }}</el-link
                  >
                </template>
              </el-table-column>
              <el-table-column width="100" prop="freeze_num" label="冻">
                <template #header>
                  <el-tooltip effect="dark" content="冻" placement="top-start">
                    <span> 冻</span>
                  </el-tooltip>
                </template></el-table-column
              >
            </el-table-column>
            <!-- <el-table-column
              v-for="(item, index) in storeList"
              :key="index"
              align="center"
              :label="item.label"
            >
              <el-table-column
                v-for="list in item.children"
                align="center"
                :prop="list.prop"
                :label="list.label"
                :key="list.prop"
              >
                <template #header>
                  <el-tooltip
                    effect="dark"
                    :content="list.label"
                    placement="top-start"
                  >
                    <span> {{ list.label }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column> -->
            <el-table-column width="150" prop="total_price" label="小计">
              <template #header>
                <el-tooltip effect="dark" content="小计" placement="top-start">
                  <span> 小计</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.total_price | money }}</template
              >
            </el-table-column>
            <el-table-column width="150" prop="avg_price" label="成本价">
              <template #header>
                <el-tooltip
                  effect="dark"
                  content="成本价"
                  placement="top-start"
                >
                  <span> 成本价</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.avg_price | money }}</template
              >
            </el-table-column>
          </el-table>
          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">
              共{{ basicListconfig.total }}项数据
            </p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </basicList>
    <!-- 显示库存明细 -->
    <shopStockNum
      v-if="shopStockNumDialogParams.visible"
      :dialogParams="shopStockNumDialogParams"
      @close="closeThePopUpWindowShopStockNum"
    ></shopStockNum>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import {
  itemClassGetList,
  getshoplist,
  userPermissionShopGetList,
} from "@/api/basicConfiguration";
import { stockItemGetStockList } from "@/api/inventoryFlow";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "inventoryFlow",
  components: {
    shopStockNum: () => import("../storeProductManagement/shopStockNum.vue"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,

      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      storeList: [],
      summarizeData: {},
      shopStockNumDialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      showZeroStock: true, // 是否显示0库存
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;
    let cacheSearchCriteria = localStorage.getItem("search");
    console.log(
      "%c [ cacheSearchCriteria ]-297",
      "font-size:13px; background:pink; color:#bf2c9f;",
      cacheSearchCriteria
    );
    if (
      cacheSearchCriteria &&
      cacheSearchCriteria != true &&
      cacheSearchCriteria !== "undefined"
    ) {
      this.$nextTick(() => {
        this.$refs.table.searchComponentAssignment(
          JSON.parse(cacheSearchCriteria)
        );
        this.obtainDataSource().then((res) => {
          this.searchEvent(JSON.parse(cacheSearchCriteria));
        });
      });
    } else {
      // 先拿基础数据
      this.obtainDataSource().then((res) => {
        // 再拉业务数据
        if (this.roleId == 4) {
          this.basicListconfig.searchParameters.shop_id =
            this.$store.getters.userInfo.shopId;
        }
        this.getlist();
      });
    }
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    // 编辑弹窗
    editShopStockNumButton(row) {
      this.shopStockNumDialogParams.key = new Date().getTime();
      this.shopStockNumDialogParams.visible = true;
      this.shopStockNumDialogParams.id = row.item_id;
    },
    closeThePopUpWindowShopStockNum() {
      this.shopStockNumDialogParams.visible = false;
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      localStorage.setItem("search", JSON.stringify(data));
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.basicListconfig.loading = true;
      // 平台超管看所有，其他人只能看自己商户店铺
      this.basicListconfig.searchParameters.comp_id = this.compId;
      if (this.roleId == 4) {
        let shop_ids = this.basicListconfig.search[0].options
          .map((item) => item.value)
          .join(",");
        if (!shop_ids) {
          this.$message.error("用户没有关联门店");
          return;
        }
        if (!this.basicListconfig.searchParameters.hasOwnProperty("shop_id")) {
          this.basicListconfig.searchParameters.shop_id = shop_ids;
        }
        if (
          this.basicListconfig.searchParameters.hasOwnProperty("shop_id") &&
          this.basicListconfig.searchParameters.shop_id == ""
        ) {
          this.basicListconfig.searchParameters.shop_id = shop_ids;
        }
      }
      // 根据 showZeroStock 设置 haveStock
      this.basicListconfig.searchParameters.haveStock = this.showZeroStock
        ? 1
        : 0;
      stockItemGetStockList(this.basicListconfig.searchParameters).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.loading = false;
            this.summarizeData.total_money = res.total_money;
            this.summarizeData.total_num = res.total_num;
            this.summarizeData.self_total_num = res.self_total_num;
            this.summarizeData.non_self_total_num = res.non_self_total_num;
            this.summarizeData.non_self_total_money = res.non_self_total_money;
            this.summarizeData.self_total_money = res.self_total_money;
            this.basicListconfig.total = Number(res.count);
            this.basicListconfig.data = res.data.map((item) => {
              item.list.map((list, index) => {
                for (const key in list) {
                  item[key] = list[key];
                }
              });
              if (Array.isArray(item.shop_list)) {
                item.shop_list.forEach((list, index) => {
                  for (const key in list) {
                    let shop_key = "shop_" + key;
                    item[shop_key] = list[key];
                  }
                });
              }
              return item;
            });
            let storeList = [];

            if (
              Array.isArray(res.data) &&
              res.data.length > 0 &&
              res.data[0] &&
              Array.isArray(res.data[0].list)
            ) {

            res.data[0].list.map((item, index) => {
              let children = [];

              let stock_single = null;
              let stock_package = null;
              let stock_total = null;
              let stock_freeze = null;
              for (const key in item) {
                if (key == "item_stock_single") {
                  stock_single = {
                    label: "散",
                    prop: key + index,
                  };
                }
                if (key == "item_stock_package") {
                  stock_package = {
                    label: "箱",
                    prop: key + index,
                  };
                }
                if (key == "num") {
                  stock_total = {
                    label: "总",
                    prop: key + index,
                  };
                }
                if (key == "freeze_num") {
                  stock_freeze = {
                    label: "冻",
                    prop: key + index,
                  };
                }
              }

              children.push(stock_single);
              children.push(stock_package);
              children.push(stock_total);
              children.push(stock_freeze);

              storeList.push({ label: item.shop_name, children: children });
            });
          }
            this.storeList = storeList;
            this.basicListconfig.total = Number(res.count);
          } else {
            this.basicListconfig.loading = false;
            this.$message.error(res.msg);
          }
        }
      );
    },
    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("库存-库存查询-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
                item.value = JSON.parse(getRoles()).shop_id;
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },

    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      return this.getShops();
    },
  },
};
</script>

<style  scoped>
.search_total {
  display: flex;
  line-height: 32px;
}
.search_total p {
  font-size: 16px;
  padding: 0 10px;
  font-weight: bold;
  color: #ffa100;
  margin-bottom: 0;
}
.search_total p span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
}
.search_total .sub-info {
   margin-bottom: 0;
  font-size: 13px;
  color: #2793FF;
  font-weight: normal;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/inventoryFlow/index.vue